import React, {useEffect, useState} from 'react'
import {Button, message, Modal, Popconfirm} from "antd"
import SelectSearchDouble from "./SelectSearchDouble";
import {assignCalloutQueue, getCalloutQueue} from "../../../../services/api/apiUser";
import parseToken from "../../../../helpers/parseToken";

const CalloutAssignModal = (props) => {
    const {usersSelected, showModal, toggleModal, getUsers, onClearChecked, listUsers} = props
    const [loading, setLoading] = useState(false)
    const [calloutId, setCalloutId] = useState('')
    const [listCalloutId, setListCalloutId] = useState([{name: "All", value: ""}])
    const decodeToken = parseToken()

    const _handleChangeCallout = (name, value) => {
        setCalloutId(value)
    }

    const handleCancel = () => {
        toggleModal()
        onClearChecked()
    }

    const onSubmit = async () => {
        setLoading(true)
        try {
            const objSelected = listUsers.filter(item => usersSelected.includes(item.userId))
            const extUsers = objSelected.map(item => item.extension)
            const payload = {
                calloutId: calloutId,
                agents: extUsers
            }

            const response = await assignCalloutQueue(payload, decodeToken.sub)

            const {success, error_message} = response
            if (parseInt(success) !== 1) {
                setLoading(false)
                message.error(error_message)
                return
            }
            toggleModal()
            getUsers()
            onClearChecked()
            message.success(error_message)
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const _fetchListCallout = async () => {
        try {
            const response = await getCalloutQueue({}, decodeToken.sub)

            const {success, data, error_message} = response
            if (parseInt(success) !== 1) {
                setLoading(false)
                message.error(error_message)
                return
            }

            const _listCall = data.map(item => {
                return {
                    name: item.calloutQueue + ' - ' + item.calloutNumber,
                    value: item.calloutId
                }
            })
            setLoading(false)
            setListCalloutId([{name: "All", value: ""}, ..._listCall])
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    useEffect(() => {
        _fetchListCallout()
        // eslint-disable-next-line
    }, [])

    return <>
        <Modal
            title="Gán nhóm gọi ra cho người dùng"
            className="ModalCustom2"
            maskClosable={false}
            visible={showModal}
            footer={[
                <div className="Actions d-flex justify-content-end align-items-center">
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleCancel} okText="Yes"
                                cancelText="No">
                        <Button key="back" type="link" disable={loading}>
                            Cancel
                        </Button>
                    </Popconfirm>
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn gán danh sách Leads?" onConfirm={onSubmit}
                                okText="Yes" cancelText="No">
                        <Button key="submit" type="primary" disabled={calloutId === ''} loading={loading}>
                            Assign
                        </Button>
                    </Popconfirm>
                </div>
            ]}
        >
            <div className="PageDefault ">
                <SelectSearchDouble name="calloutId" value={calloutId}
                                    onChange={_handleChangeCallout} label="Nhóm gọi ra"
                                    listSelect={listCalloutId}/>
            </div>
        </Modal>
    </>
}

export default CalloutAssignModal
